import isArray from 'lodash/isArray';

import { Head } from '../models';
import { CDN_BASE_URL } from '../networking/constants';

const prefetch = (url: string) => {
  // check if link for this url already exists
  if (document.querySelectorAll(`[href="${url}"]`).length) {
    return;
  }

  const link = document.createElement('link');
  link.setAttribute('rel', 'prefetch');
  link.setAttribute('href', url);

  document.head.appendChild(link);
};

function addStylesheet(documentId: string, css: string) {
  const id = `candu-stylesheet-${documentId}`;
  if (document.getElementById(id)) {
    return;
  }
  const style = document.createElement('style');
  style.setAttribute('id', id);
  style.setAttribute('type', 'text/css');

  style.appendChild(document.createTextNode(css));

  document.head.append(style);
}

export const fetchHead = (head: Head[], clientToken: string) => {
  if (!head || !isArray(head)) {
    return;
  }
  addStylesheet(
    'document',
    `.candu-document * {
      box-sizing: border-box;
    }
  `,
  );

  head.map(({ nodeType, url }) => {
    if (nodeType === 'EmbedTutorial') {
      return prefetch(`${CDN_BASE_URL}/tutorials/${clientToken}/${url}.json`);
    }
    if (nodeType === 'EmbedPortal') {
      return prefetch(`${CDN_BASE_URL}/portals/${clientToken}/${url}/head.json`);
    }
    return prefetch(url);
  });
};
